import { Bounds, LatLngBounds, Map, Proj } from 'leaflet';
import { ReactElement, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import {
	crsSvgOverlayOverwrite,
	svgOverlayOverwrite
} from '../../../utils/leaflet-overwrites';

export interface ICustomSvgOverlayProps {
	id: string;
	imageText: string;
	bounds: LatLngBounds;
	crs?: Proj.CRS;
}

export function CustomSvgOverlay(props: ICustomSvgOverlayProps): ReactElement {
	const { id, imageText, bounds, crs } = props;
	const map: Map = useMap();

	useEffect(() => {
		const svgOverlay: any = crs ? createCrsSvgLayer() : createSvgLayer();

		return () => {
			if (svgOverlay && map) {
				map.removeLayer(svgOverlay);
			}
		};
	}, []);

	function createCrsSvgLayer(): any {
		const projectedBounds: Bounds = new Bounds(
			crs!.project(bounds.getSouthEast()),
			crs!.project(bounds.getNorthWest())
		);
		const svgOverlay = crsSvgOverlayOverwrite('', projectedBounds).addTo(
			map
		);
		svgOverlay.setId(id);
		svgOverlay.setInnerHtml(imageText);

		return svgOverlay;
	}

	function createSvgLayer(): any {
		const svgOverlay = svgOverlayOverwrite('', bounds).addTo(map);
		svgOverlay.setId(id);
		svgOverlay.setInnerHtml(imageText);

		return svgOverlay;
	}

	return <></>;
}
